import React, { Component } from 'react';
import { Container, Grid, Segment, Header, Table, Label, Button, Image, List, Loader } from 'semantic-ui-react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import Moment from 'moment';
import {
    getHradminEmployeeInpatientClaimData,
} from '../../../actions';
import ClaimStatusLabel from '../../../component/claim/claim_status_label';

class HradminEmployeeViewClaimDetailInpPage extends Component {
    state = {
        selectedAttachmentId: null,
        viewUrl: null,
        openDeleteDialog: false,
        deleteThisClaim: false,
        deleteThisClaimResult: null,
    };
    componentDidMount() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const {uuid} = this.props.match.params;
        const {accessToken} = this.props.user;
        this.props.getHradminEmployeeInpatientClaimData({
            transactionNo: claimTransactionNo,
            userId: uuid,
            accessToken
        });
    }
    setSelectedAttachmentId(attachmentId, viewUrl) {
        this.setState({selectedAttachmentId: attachmentId, viewUrl});
    }
    renderAttachmentList(attachments) {
        return _.map(attachments, (attachment, index) => {
            const { filename, viewUrl } = attachment;
            return (
                <List.Item key={filename}>
                    <List.Content floated='right'>
                        <Button
                            onClick={() => this.setSelectedAttachmentId(filename, viewUrl)}
                            disabled={this.state.selectedAttachmentId === filename}
                        >
                            View
                        </Button>
                    </List.Content>
                    <List.Content>
                        <Label color='red' horizontal>
                            IMG
                        </Label>
                        Uploaded Document {index + 1}
                    </List.Content>
                </List.Item>
            );
        });
    }
    renderSelectedAttachment() {
        if (this.state.selectedAttachmentId && this.state.viewUrl) {
            return (
                <Image src={this.state.viewUrl} />
            );
        }
    }
    render() {
        const claimTransactionNo = this.props.match.params.claimTransactionNo;
        const targetUuid = this.props.match.params.uuid;
        const selectedInpatientClaim = this.props.employeeClaimData;
        if (!selectedInpatientClaim || claimTransactionNo !== this.props.selectedClaimToView || targetUuid !== this.props.selectedEmployeeToView) {
            return (
                <Loader active />
            );
        }
        const {
            transactionNo,
            status,
            remarks,
            admissionDate,
            dischargeDate,
            reasonForTreatment,
            nameOfOperation,
            originalAmount,
            payableAmount,
            providerName,
            attachment,
            name,
            claimDocumentUrl
        } = selectedInpatientClaim;
        return (
            <Container fluid>
                <Header as='h2' block>
                    Claim Details - {transactionNo}
                </Header>
                <Grid columns={2}>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Status
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Status
                                        </Table.Cell>
                                        <Table.Cell>
                                            <ClaimStatusLabel status={status} />
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Remarks
                                        </Table.Cell>
                                        <Table.Cell>
                                            {remarks}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claimant
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Name
                                        </Table.Cell>
                                        <Table.Cell>
                                            {name}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                        <Header as='h4' attached='top' block>
                            Claim Details
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            Transaction No
                                        </Table.Cell>
                                        <Table.Cell>
                                            {transactionNo}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            PDF Document
                                        </Table.Cell>
                                        <Table.Cell>
                                            <a href={claimDocumentUrl} target="_blank">
                                                <Button>View</Button>
                                            </a>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Hospital
                                        </Table.Cell>
                                        <Table.Cell>
                                            {providerName}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Admission Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            { Moment(admissionDate, 'D/M/YYYY').format('DD MMM YYYY') }
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Discharge Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            { Moment(dischargeDate, 'D/M/YYYY').format('DD MMM YYYY') }
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Reason For Treatment
                                        </Table.Cell>
                                        <Table.Cell>
                                            {reasonForTreatment}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Name of Operation
                                        </Table.Cell>
                                        <Table.Cell>
                                            {nameOfOperation}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Amount
                                        </Table.Cell>
                                        <Table.Cell>
                                            {
                                                (payableAmount) ?
                                                (
                                                    <div>
                                                        <Label color='green' horizontal>
                                                            {originalAmount.currency}
                                                        </Label>
                                                        {payableAmount}
                                                    </div>
                                                )
                                                : 'Pending'
                                            }
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <Segment.Group>
                            <Header as='h4' attached='top' block>
                                Documents
                            </Header>
                            <Segment attached>
                                <List divided>
                                    {this.renderAttachmentList(attachment)}
                                </List>
                            </Segment>
                            <Segment attached>
                                {this.renderSelectedAttachment()}
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        employeeClaimData: state.hradmin.employeeClaimData,
        selectedEmployeeToView: state.hradmin.selectedEmployeeToView,
        selectedClaimToView: state.hradmin.selectedClaimToView,
    }
}

export default connect(mapStateToProps, {
    getHradminEmployeeInpatientClaimData,
})(HradminEmployeeViewClaimDetailInpPage);
